import { useState } from "react";
import "./Home.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// import { useNavigate } from "react-router-dom";
import digital from "../../assets/images/digital.png";
import multipleIns from "../../assets/images/multipleIns.png";
import lowInterest from "../../assets/images/lowINTEREST.png";
import collateral from "../../assets/images/collateral.png";
import teamWork from "../../assets/images/team-work_rafiki.svg";
import cuate from "../../assets/images/cuate@2x.png";
import approval from "../../assets/images/Approval.png";
import qrCode from "../../assets/images/My_App_QR.png";
import playStore from "../../assets/images/Group.svg";
import leftAward from "../../assets/images/Group-2.svg";
import rightAward from "../../assets/images/Group-3.svg";
import sanjay from "../../assets/images/sanjay.png";
import raj from "../../assets/images/raj.png";
import someshwar from "../../assets/images/someshwar.png";
import yourStory from "../../assets/images/logo_yourstory_new.svg";
import liveMint from "../../assets/images/live_mint_logo.webp";
import inc42 from "../../assets/images/inc42-new-logo.png";
import etLogo from "../../assets/images/ET_logo.webp";
import hinduLogo from "../../assets/images/the_hindu_logo.webp";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

const Home = () => {
  // const navigate = useNavigate();
  const [showVideo, setShowVideo] = useState(false);
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  const homeFaqs = [
  {
    question:
      "How can Finsall help in improving sales from existing customers?",
    answer:
      "Your existing customers typically would understand the need of insurance and value it already. However, because of their budget constraints they might still be under-insured. Those customers can now be provided appropriate insurance as they would need to pay much lesser amount upfront. Providing premium financing to your existing customers will also help in improving retention as in the subsequent years the customers will request for similar services."
  },
  {
    question:
      "How can Finsall help in capturing new market and products?",
    answer:
      "Finsall's approach of helping customers meet their premium payment obligation is an innovative approach as it addresses the initial hick-ups of the proposer. Insurance premium financing can be very helpful in attracting new customers segments, where certain types of insurance products can now become relevant because of financing options. Insurance premium financing specially helps for products which the customer’s realize the need of insurance but still don’t budget for it. Please get in touch with us to know how you can target new customer segments and products."
  },
  {
    question:
      "Does Finsall sell or suggest insurance to customers?",
    answer:
      "Finsall will never sell insurance policies. The intent is simple we want to be the trusted partner with the existing insurance sales channels and not become a competition. In accordance to the above, we have not taken any license (agency / broking) and in future also we will only concentrate on financing of insurance."
  }
];

  const features = [
    {
      title: "Digital process",
      image: digital,
      description:
        "End-to-end digital process removes the need for physical presence or documentation. Get premium financed in under 5 mins.",
    },
    {
      title: "Multiple Insurance",
      image: multipleIns,
      description:
        "All general insurance types like motor, health, fire, homeowners, group mediclaim, and health multi-year can be easily financed.",
    },
    {
      title: "Low Interest Rate",
      image: lowInterest,
      description:
        "Competitive interest rate helps even the best customers choose premium financing options and buy adequate insurance.",
    },
    {
      title: "No Collateral Security",
      image: collateral,
      description:
        "No need for proof of income or additional collateral security of any kind is required from customers to avail loan.",
    },
  ];

  const testimonials = [
  {
    image: sanjay,
    name: "Mr Sanjay T",
    designation: "Insurance Intermediary",
    text: `Finsall has been an absolute pleasure to work with. "When we
                            provide service to someone, the most crucial element to consider is Response," and your
                            response has always been excellent and prompt whenever needed. Customers have also embraced
                            and praised the concept of insurance premium financing. Finsall's portal/App has been a
                            really smooth experience. In a nutshell, I'll say the expression of working  with finsall
                            has been outstanding.`
  },
  {
    image: raj,
    name: "Mr Raj G",
    designation: "Insurance Intermediary",
    text: `We've been working with Finsall for about a year now. If you
                            ask me to rate the experience, I'd give it a 9 out of 10. Responses have always been quite
                            quick on your end. I’ll say the overall experience till now is up to the mark & excellent.
                            Customers are also pleased because purchasing insurance policies has become more affordable.
                            Your are in a true sense working towards INSURANCE FOR ALL and we are looking forward to
                            work with Finsall in future as well.`
  },
  {
    image: someshwar,
    name: "Mr Someshwar S",
    designation: "Insurance Intermediary",
    text: `We have always enjoyed working with Finsall. By offering insurance premium financing, 
                            which also aids in the market's expansion for insurance companies, Finsall is playing a significant role in the 
                            insurance industry. So it generates a win-win situation for everyone and is also helping us in certain ways to grow 
                            our business. We've received timely assistance from your end every-time we've required it, therefore we're very much 
                            happy to work with Finsall.`
  }
];

  return (
    <>

<title>Premium Finance India for Easy Insurance EMI</title>
<meta
  name="description"
  content="Finance any general insurance premium with easy EMIs using a digital process, low interest and no collateral. Finsall makes premium financing affordable."
/>

    <Header />
    <main>
      {/* HERO SECTION */}

       <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <h1>
              Financing Insurance Premiums
              <br />
              made simple and affordable
            </h1>

            <p>
              Bringing insurance intermediaries, customers,
              insurers, and lenders together to FINANCE INSURANCE through easy monthly installments
              without any need for additional collateral.
            </p>

            <div className="hero-buttons">
              <button className="primary-btn"
              onClick={() =>
              window.location.href = "/contact-us"
            }
              >
                Contact Us
              </button>

              <button
                className="secondary-btn"
                onClick={() => setShowVideo(true)}
              >
                Watch Video
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* VIDEO MODAL */}

      {showVideo && (
        <div
          className="video-overlay"
          onClick={() => setShowVideo(false)}
        >
          <div
            className="video-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="close-btn"
              onClick={() => setShowVideo(false)}
            >
              ×
            </button>

            <video controls autoPlay playsInline>
              <source
                src="https://s3.ap-south-1.amazonaws.com/www.finsall.co.in/w.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </div>
      )}

      {/* FEATURES */}

      <section className="features-section">
  <div className="container">

    {/* Desktop Grid */}
    <div className="feature-grid desktop-grid">
      {features.map((feature) => (
        <div className="feature-card" key={feature.title}>
          <img src={feature.image} alt={feature.title} />
          <h3>{feature.title}</h3>
          <p>{feature.description}</p>
        </div>
      ))}
    </div>

    {/* Mobile + Tablet Swiper */}
    <Swiper 
      modules={[Navigation, Pagination]}
      navigation
      pagination={{ clickable: true }}
      loop={true}
      spaceBetween={16}
      breakpoints={{
        0: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
      }}
      className="feature-swiper"
    >
      {features.map((feature) => (
        <SwiperSlide key={feature.title}>
          <div className="feature-card">
            <img src={feature.image} alt={feature.title} />
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>

  </div>
</section>

      {/* FOR INSURERS */}

    <section className="info-section">
       <div className="container">
        <div className="info-grid reverse">
          <div className="info-content">
          <span className="section-tag">
          FOR INSURERS
          </span>

        <h2>
          Here is why insurance companies trust
          Finsall
        </h2>

        <p>
          Finsall is an honest partner to the insurance ecosystem; we pledge never to sell insurance policies. This enables us to be a trusted partner for insurers and their sales channels. Now premium financing can be offered within the insured’s purchase flow, all of this by integrating one simple API.
        </p>

        <button className="info-btn" 
        onClick={() =>
              window.location.href = "/how-it-works"
            }>
  View Process
</button>
      </div>

      <div className="info-image">
        <img
          src={teamWork}
          alt="collaborative team illustration showing integration for insurers"
        />
      </div>
    </div>
  </div>
</section>

{/* FOR INTERMEDIARIES */}

<section className="intermediaries-section">
  <div className="container">
    <div className="info-grid">
      

      <div className="info-content">
        <span className="section-tag">
          FOR INSURANCE INTERMEDIARIES
        </span>

        <p>
          View the process journey to
          understand how others are using
          premium financing to increase
          their business.
        </p>

        <button className="info-btn" 
        onClick={() =>
              window.location.href = "/intermediaries"
            }>
          View Solution
        </button>

        <h4>
          Here is how Finsall simplifies
          customer experience
        </h4>

        <ul className="benefits-list">
          <li>
            <img src={approval} alt="" />
            Removing budget constraints
          </li>

          <li>
            <img src={approval} alt="" />
            Paperless process
          </li>

          <li>
            <img src={approval} alt="" />
            Easy EMI calculator
          </li>

          <li>
            <img src={approval} alt="" />
            Quick approvals
          </li>

          <li>
            <img src={approval} alt="" />
            On call support
          </li>

          <li>
            <img src={approval} alt="" />
            Differentiated offering
          </li>
        </ul>
      </div>
      <div className="info-image">
        <img
          src={cuate}
          alt="llustration of user checking insurance EMI on mobile app"
        />
      </div>
    </div>
  </div>
</section>

{/* DOWNLOAD APP */}

<section className="download-section">

  <div className="download-banner">
  <div className="download-qr">
    <img src={qrCode} alt="QR Code" />
  </div>

  <div className="download-content">
    <h2>
      Onboard your <span>Customers Online</span>
    </h2>

    <p>Download Our Free App From</p>

   <a
          href="https://play.google.com/store/apps/details?id=com.finsall"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={playStore}
            alt="google play download button for intermediary app"
            className="playstore-btn"
          />
        </a>
  </div>
</div>
</section>

{/* =========================================
          AWARDS SECTION
      ========================================= */}

      <section className="awards-section">

  {/* Desktop */}

  <div className="awards-grid desktop-awards">

    <div className="award-card">
      <img src={leftAward} alt="" className="award-left" />
      <img src={rightAward} alt="" className="award-right" />

      <h3>
        Best Customer
        <br />
        Focused
        <br />
        Innovation Award
      </h3>

      <span>BY:</span>

      <h4>
        INDIA INSURTECH ASSOCIATION
      </h4>
    </div>

    <div className="award-card">
      <img src={leftAward} alt="" className="award-left" />
      <img src={rightAward} alt="" className="award-right" />

      <h3>
        Recognized as a
        <br />
        Success Story in
        <br />
        IRDA Sandbox
      </h3>

      <span>BY:</span>

      <h4>IRDA</h4>
    </div>

    <div className="award-card">
      <img src={leftAward} alt="" className="award-left" />
      <img src={rightAward} alt="" className="award-right" />

      <h3>
        12 Lakhs Scale-up
        <br />
        Grant Winner
      </h3>

      <span>BY:</span>

      <h4>
        KERALA STARTUP MISSION
      </h4>
    </div>

  </div>

  {/* Mobile + Tablet */}

  <Swiper
    modules={[Navigation, Pagination]}
    navigation
    pagination={{ clickable: true }}
    loop={true}
    spaceBetween={20}
    breakpoints={{
      0: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1,
      },
    }}
    className="awards-swiper"
  >

    <SwiperSlide>
      <div className="award-card">
        <img src={leftAward} alt="" className="award-left" />
        <img src={rightAward} alt="" className="award-right" />

        <h3>
          Best Customer
          <br />
          Focused
          <br />
          Innovation Award
        </h3>

        <span>BY:</span>

        <h4>
          INDIA INSURTECH ASSOCIATION
        </h4>
      </div>
    </SwiperSlide>

    <SwiperSlide>
      <div className="award-card">
        <img src={leftAward} alt="" className="award-left" />
        <img src={rightAward} alt="" className="award-right" />

        <h3>
          Recognized as a
          <br />
          Success Story in
          <br />
          IRDA Sandbox
        </h3>

        <span>BY:</span>

        <h4>IRDA</h4>
      </div>
    </SwiperSlide>

    <SwiperSlide>
      <div className="award-card">
        <img src={leftAward} alt="" className="award-left" />
        <img src={rightAward} alt="" className="award-right" />

        <h3>
          12 Lakhs Scale-up
          <br />
          Grant Winner
        </h3>

        <span>BY:</span>

        <h4>
          KERALA STARTUP MISSION
        </h4>
      </div>
    </SwiperSlide>

  </Swiper>

</section>
      
{/* =========================================
          COUNTER SECTION
      ========================================= */}

      <section className="stats-section">

        <div className="stats-grid">

          <div className="stat-item">
            <h2>15,000+</h2>
            <p>Cities / Towns Serviced</p>
          </div>

          <div className="stat-item">
            <h2>50,000+</h2>
            <p>Intermediaries</p>
          </div>

          <div className="stat-item">
            <h2>8,30,000+</h2>
            <p>Lives Impacted</p>
          </div>

        </div>

      </section>

{/* TESTIMONIALS */}

<section className="home-testimonials-section">

  <div className="home-container">

    <h2 className="testimonial-title">
      Insurance Intermediary Testimonials
    </h2>

    <Swiper
      modules={[Navigation, Pagination]}
      loop={true}
      breakpoints={{
  0: {
    slidesPerView: 1,
  },
  768: {
    slidesPerView: 2,
  },
}}
      spaceBetween={45}
      navigation
      pagination={{ clickable: true }}
      className="testimonial-swiper"
    >
      {testimonials.map((item, index) => (
        <SwiperSlide key={index}>

          <div className="testimonial-card">

            <p className="testimonial-text">
              {item.text}
            </p>

            <div className="testimonial-user">

              <img
                src={item.image}
                alt={item.name}
              />

              <div>
                <h4>{item.name}</h4>
                <span>{item.designation}</span>
              </div>

            </div>

          </div>

        </SwiperSlide>
      ))}
    </Swiper>

  </div>

</section>

{/* FEATURED IN */}

<section className="featured-section">
  <div className="container">

    <h2 className="section-heading">
      Featured In
    </h2>

    <div className="featured-grid">

      <a
        href="https://yourstory.com/"
        target="_blank"
        rel="noreferrer"
      >
        <img src={yourStory} alt="YourStory logo" />
      </a>

      <a
        href="https://www.livemint.com/"
        target="_blank"
        rel="noreferrer"
      >
        <img src={liveMint} alt="LiveMint logo" />
      </a>

      <a
        href="https://inc42.com/"
        target="_blank"
        rel="noreferrer"
      >
        <img src={inc42} alt="Inc42 logo" />
      </a>

      <a
        href="https://economictimes.indiatimes.com/"
        target="_blank"
        rel="noreferrer"
      >
        <img src={etLogo} alt="ET logo" />
      </a>

      <a
        href="https://www.thehindubusinessline.com/"
        target="_blank"
        rel="noreferrer"
      >
        <img src={hinduLogo} alt="BusinessLine logo" />
      </a>

    </div>

  </div>
</section>

{/* =========================================
          FAQ SECTION
      ========================================= */}

      <section className="home-faq-section">

        <div className="home-faq-header">

          <h2>
            Frequently Asked Questions
          </h2>

          <p>
            Get answers to some of the most
            pertinent questions
          </p>

        </div>

        <div className="home-faq-wrapper">

          {homeFaqs.map((faq, index) => (

            <div
              key={index}
              className={`home-faq-card ${
                openFaq === index ? "active" : ""
              }`}
            >

              <button
                className="home-faq-question"
                onClick={() =>
                  setOpenFaq(
                    openFaq === index ? null : index
                  )
                }
              >

                <span>{faq.question}</span>

                <span className="faq-toggle">
  {openFaq === index ? "⌃" : "⌄"}
</span>

              </button>

              {openFaq === index && (

                <div className="home-faq-answer">

                  <p>{faq.answer}</p>

                </div>

              )}

            </div>

          ))}

        </div>

        <div className="faq-btn-wrapper">

          <button
            className="primary-btn"
            onClick={() =>
              window.location.href = "/faq"
            }
          >
            Browse All FAQs
          </button>

        </div>

      </section>
    </main>
    <Footer/>
    </>
  );
};


export default Home;